import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-download-citation-dialog',
  templateUrl: './download-citation-dialog.component.html',
})
export class DownloadCitationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadCitationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { citationText: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
